import { render, staticRenderFns } from "./info-view.vue?vue&type=template&id=633ad146&scoped=true"
import script from "./info-view.ts?vue&type=script&lang=ts&external"
export * from "./info-view.ts?vue&type=script&lang=ts&external"
import style0 from "./info-view.less?vue&type=style&index=0&id=633ad146&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ad146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633ad146')) {
      api.createRecord('633ad146', component.options)
    } else {
      api.reload('633ad146', component.options)
    }
    module.hot.accept("./info-view.vue?vue&type=template&id=633ad146&scoped=true", function () {
      api.rerender('633ad146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/info-view.vue"
export default component.exports